import { Col, Form, message, Row } from "antd";
import React, { useState } from "react";
import {
  StyledButton,
  StyledPasswordInput,
} from "../../components/styledComponent/styledElements";
import { MdPassword } from "react-icons/md";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { changePassword } from "../../server/authServer";
import { ShowNotification } from "../../components/notification/notification";

function SettingPage() {
  const [requirements, setRequirements] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  const [form] = Form.useForm();

  const validatePassword = (value) => {
    const length = value.length >= 8;
    const uppercase = /[A-Z]/.test(value);
    const lowercase = /[a-z]/.test(value);
    const number = /[0-9]/.test(value);
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    setRequirements({ length, uppercase, lowercase, number, specialChar });
    return length && uppercase && lowercase && number && specialChar;
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    validatePassword(password);
  };

  const onFinish = (values) => {
    if (validatePassword(values.new_password)) {
      changePassword(values)
        .then((res) => {
          if (res.status === "success") {
            ShowNotification({
              type: "success",
              message: "Password changed successfully",
            });
            form.resetFields();
          } else {
            ShowNotification({
              type: "error",
              message: res.data,
            });
          }
        })
        .catch((err) => {
          ShowNotification({
            type: "error",
            message: err.response.data.message,
          });
        });
    } else {
      message.error("Password does not meet the requirements!");
    }
  };

  return (
    <StyledContentCard title={"Settings"}>
      <div>
        <p className="subheading-content">Change your Password</p>
      </div>
      <Row gutter={32}>
        <Col span={8}>
          <Form
            className="loginForm"
            form={form}
            onFinish={onFinish}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="old_password"
              rules={[
                { required: true, message: "Please enter your old password!" },
              ]}
            >
              <StyledPasswordInput
                width={"100%"}
                prefix={<MdPassword style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Enter old password"
              />
            </Form.Item>
            <Form.Item
              name="new_password"
              rules={[
                { required: true, message: "Please enter your new password!" },
                {
                  validator: (_, value) =>
                    validatePassword(value)
                      ? Promise.resolve()
                      : Promise.reject(
                          "Password must meet the above requirements!"
                        ),
                },
              ]}
            >
              <StyledPasswordInput
                width={"100%"}
                prefix={<MdPassword style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Enter new password"
                onChange={handlePasswordChange}
              />
            </Form.Item>
            <Form.Item
              name={"confirm_password"}
              rules={[
                {
                  required: true,
                  message: "Please confirm your new password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Passwords do not match!");
                  },
                }),
              ]}
            >
              <StyledPasswordInput
                width={"100%"}
                prefix={<MdPassword style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Confirm new password"
              />
            </Form.Item>
            <Form.Item>
              <StyledButton
                width={"100%"}
                htmlType="submit"
                disabled={!Object.values(requirements).every(Boolean)}
              >
                Update Password
              </StyledButton>
            </Form.Item>
          </Form>
        </Col>
        <Col span={8}>
          <ul className="list-disc pl-5 space-y-1">
            <li
              className={`${
                requirements.length ? "text-green-500" : "text-red-500"
              }`}
            >
              Minimum 8 characters
            </li>
            <li
              className={`${
                requirements.uppercase ? "text-green-500" : "text-red-500"
              }`}
            >
              At least one uppercase letter
            </li>
            <li
              className={`${
                requirements.lowercase ? "text-green-500" : "text-red-500"
              }`}
            >
              At least one lowercase letter
            </li>
            <li
              className={`${
                requirements.number ? "text-green-500" : "text-red-500"
              }`}
            >
              At least one number
            </li>
            <li
              className={`${
                requirements.specialChar ? "text-green-500" : "text-red-500"
              }`}
            >
              At least one special character
            </li>
          </ul>
        </Col>
      </Row>
    </StyledContentCard>
  );
}

export default SettingPage;
